const SectionHeaderData = ({ sectionTitle, sectionTitleType }: { sectionTitle: string; sectionTitleType: string }) => {
  return (
    <div className="document-details-section-header-data">
      <div className="document-details-section-header-data-title">{sectionTitle}</div>
      <div className="document-details-section-header-data-type">{sectionTitleType}</div>
    </div>
  )
}

export default SectionHeaderData
